import unstable_createElement from './exports/createElement';
import findNodeHandle from './exports/findNodeHandle';
import processColor from './exports/processColor';
import render from './exports/render';
import unmountComponentAtNode from './exports/unmountComponentAtNode';
import NativeModules from './exports/NativeModules';

// APIs
import AccessibilityInfo from './exports/AccessibilityInfo';
import Alert from './exports/Alert';
import Animated from './exports/Animated';
import Appearance from './exports/Appearance';
import AppRegistry from './exports/AppRegistry';
import AppState from './exports/AppState';
import BackHandler from './exports/BackHandler';
import Clipboard from './exports/Clipboard';
import Dimensions from './exports/Dimensions';
import Easing from './exports/Easing';
import I18nManager from './exports/I18nManager';
import Keyboard from './exports/Keyboard';
import InteractionManager from './exports/InteractionManager';
import LayoutAnimation from './exports/LayoutAnimation';
import Linking from './exports/Linking';
import NativeEventEmitter from './exports/NativeEventEmitter';
import PanResponder from './exports/PanResponder';
import PixelRatio from './exports/PixelRatio';
import Platform from './exports/Platform';
import Share from './exports/Share';
import StyleSheet from './exports/StyleSheet';
import UIManager from './exports/UIManager';
import Vibration from './exports/Vibration';

// components
import ActivityIndicator from './exports/ActivityIndicator';
import Button from './exports/Button';
import CheckBox from './exports/CheckBox';
import FlatList from './exports/FlatList';
import Image from './exports/Image';
import ImageBackground from './exports/ImageBackground';
import KeyboardAvoidingView from './exports/KeyboardAvoidingView';
import Modal from './exports/Modal';
import Picker from './exports/Picker';
import Pressable from './exports/Pressable';
import ProgressBar from './exports/ProgressBar';
import RefreshControl from './exports/RefreshControl';
import SafeAreaView from './exports/SafeAreaView';
import ScrollView from './exports/ScrollView';
import SectionList from './exports/SectionList';
import StatusBar from './exports/StatusBar';
import Switch from './exports/Switch';
import Text from './exports/Text';
import TextInput from './exports/TextInput';
import Touchable from './exports/Touchable';
import TouchableHighlight from './exports/TouchableHighlight';
import TouchableNativeFeedback from './exports/TouchableNativeFeedback';
import TouchableOpacity from './exports/TouchableOpacity';
import TouchableWithoutFeedback from './exports/TouchableWithoutFeedback';
import View from './exports/View';
import VirtualizedList from './exports/VirtualizedList';
import YellowBox from './exports/YellowBox';
import LogBox from './exports/LogBox';

// plugins
import DeviceEventEmitter from './exports/DeviceEventEmitter';

// hooks
import useColorScheme from './exports/useColorScheme';
import useLocaleContext from './exports/useLocaleContext';
import useWindowDimensions from './exports/useWindowDimensions';

export {
    unstable_createElement,
    findNodeHandle,
    processColor,
    render,
    unmountComponentAtNode,
    NativeModules,
    // APIs
    AccessibilityInfo,
    Alert,
    Animated,
    Appearance,
    AppRegistry,
    AppState,
    BackHandler,
    Clipboard,
    Dimensions,
    Easing,
    I18nManager,
    Keyboard,
    InteractionManager,
    LayoutAnimation,
    Linking,
    NativeEventEmitter,
    PanResponder,
    PixelRatio,
    Platform,
    Share,
    StyleSheet,
    UIManager,
    Vibration,
    // components
    ActivityIndicator,
    Button,
    CheckBox,
    FlatList,
    Image,
    ImageBackground,
    KeyboardAvoidingView,
    Modal,
    Picker,
    Pressable,
    ProgressBar,
    RefreshControl,
    SafeAreaView,
    ScrollView,
    SectionList,
    StatusBar,
    Switch,
    Text,
    TextInput,
    Touchable,
    TouchableHighlight,
    TouchableNativeFeedback,
    TouchableOpacity,
    TouchableWithoutFeedback,
    View,
    VirtualizedList,
    YellowBox,
    LogBox,
    // plugins
    DeviceEventEmitter,
    // hooks
    useColorScheme,
    useLocaleContext,
    useWindowDimensions,
}
    
var ReactNative = {
    unstable_createElement,
    findNodeHandle,
    processColor,
    render,
    unmountComponentAtNode,
    NativeModules,
    // APIs
    AccessibilityInfo,
    Alert,
    Animated,
    Appearance,
    AppRegistry,
    AppState,
    BackHandler,
    Clipboard,
    Dimensions,
    Easing,
    I18nManager,
    Keyboard,
    InteractionManager,
    LayoutAnimation,
    Linking,
    NativeEventEmitter,
    PanResponder,
    PixelRatio,
    Platform,
    Share,
    StyleSheet,
    UIManager,
    Vibration,
    // components
    ActivityIndicator,
    Button,
    CheckBox,
    FlatList,
    Image,
    ImageBackground,
    KeyboardAvoidingView,
    Modal,
    Picker,
    Pressable,
    ProgressBar,
    RefreshControl,
    SafeAreaView,
    ScrollView,
    SectionList,
    StatusBar,
    Switch,
    Text,
    TextInput,
    Touchable,
    TouchableHighlight,
    TouchableNativeFeedback,
    TouchableOpacity,
    TouchableWithoutFeedback,
    View,
    VirtualizedList,
    YellowBox,
    LogBox,
    // plugins
    DeviceEventEmitter,
    // hooks
    useColorScheme,
    useLocaleContext,
    useWindowDimensions,
}

export default ReactNative;
